<template>
    <div>
        <h1 style="font-size: 24px; color: black;">APP广告ID配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增应用')">新增应用</el-button>
            </el-col>
        </el-row>
        <el-col :span="10">
            <span>渠道</span>
            <el-select v-model="queryData.channels" placeholder="请选择" multiple filterable>
                <el-option
                    v-for="item in aiIosBookChannelList"
                    :key="item.channel"
                    :label="item.remark"
                    :value="item.channel">
                </el-option>
            </el-select>
            <span>app应用</span>
            <el-select v-model="queryData.appIds" placeholder="请选择" multiple filterable>
                <el-option
                    v-for="item in apps"
                    :key="item.appId"
                    :label="item.appName"
                    :value="item.appId">
                </el-option>
            </el-select>
        </el-col>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="appId" label="应用" align="center" :formatter="appFormatter"></el-table-column>
                <!-- 渠道格式化 -->
                <el-table-column prop="channels" label="渠道" align="center"
                                 :formatter="channelFormatter"></el-table-column>
                <!-- 新增 是否生效 -->
                <el-table-column prop="deleted" label="是否生效" align="center"
                                 :formatter="statusFormatter"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="saveBase">
                <el-form-item label="应用名称" :label-width="labelWidth">
                    <el-select v-model="saveBase.appId" filterable>
                        <el-option
                            v-for="item in apps"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" :label-width="labelWidth">
                    <el-select v-model="saveBase.channels" placeholder="请选择" multiple filterable>
                        <el-option
                            v-for="item in aiIosBookChannelList"
                            :key="item.channel"
                            :label="item.remark"
                            :value="item.channel">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" :label-width="labelWidth">
                    <el-input v-model="saveBase.remark"></el-input>
                </el-form-item>
                <el-form-item label="大于等于版本号" :label-width="labelWidth">
                    <el-input v-model="saveBase.versionCode"></el-input>
                </el-form-item>
                <el-form-item label="是否可用：" :label-width="labelWidth">
                    <el-switch v-model="saveBase.deleted"
                               :active-value="false"
                               :inactive-value="true"
                               active-text="开启"
                               inactive-text="关闭">
                    </el-switch>
                </el-form-item>
            </el-form>

            <div style="margin:10px 0;">
                <el-button type="success" @click="addDetailGroup">+ 添加一组广告配置</el-button>
            </div>

            <div
                v-for="(item, index) in detailList"
                :key="index"
                style="border:1px solid #E4E7ED; padding:15px; margin-bottom:15px; border-radius:5px;">
                <div style="display: flex; justify-content: space-between; margin-bottom:10px;">
                    <span>第 {{ index + 1 }} 组广告配置</span>
                    <el-button type="danger" size="mini" @click="deleteDetailGroup(index)">删除本组</el-button>
                </div>

                <el-form :model="item" :label-width="labelWidth">
                    <el-form-item label="组别">
                        <el-input v-model="item.ab"></el-input>
                    </el-form-item>
                    <el-form-item label="比例 每个都填10以上 和并不一定非得是100">
                        <el-input v-model="item.rate"></el-input>
                    </el-form-item>
                    <el-form-item label="测试设备码用,分割">
                        <el-input v-model="item.deviceCode"></el-input>
                    </el-form-item>
                    <!-- 你要的3个广告位 -->
                    <el-form-item label="开屏">
                        <el-input v-model="item.topon_splashId"></el-input>
                    </el-form-item>
                    <el-form-item label="热启开屏">
                        <el-input v-model="item.topon_hotSplashId"></el-input>
                    </el-form-item>
                    <el-form-item label="首页插屏">
                        <el-input v-model="item.topon_InterstitialId"></el-input>
                    </el-form-item>

                </el-form>
            </div>

            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {appAll} from '@/http/api'
import {adDetails, adList, kittyChannelList, removeAdId, saveAdId} from "../../../http/aiBookAdminApi";
import settingMix from '@/utils/mix/common-setting'

export default {
    name: "AdAbAi",
    mixins: [settingMix],
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '160px',
            list: [],
            apps: [],
            saveBase: {},
            detailList: [],
            queryData: {},
            originalBase: null,
            needAiBookChannel: true,
            aiIosBookChannelList: [],
            aiIosBookChannelObject: {},
        }
    },
    methods: {
        getOriginalDetail() {
            return {
                ab: null,
                rate: null,
                deviceCode: null,
                // 只保留你要的3个字段
                topon_splashId: null,
                topon_hotSplashId: null,
                topon_InterstitialId: null,
            }
        },
        addDetailGroup() {
            this.detailList.push(this.getOriginalDetail())
        },
        deleteDetailGroup(index) {
            this.detailList.splice(index, 1)
        },
        // 应用名称格式化
        appFormatter(row, column, cellValue) {
            let temp = ""
            this.apps.forEach(item => {
                if (item.appId === cellValue) temp = item.appName
            })
            return temp
        },
        // 渠道格式化  code => 中文备注
        channelFormatter(row, column, cellValue) {
            if (!cellValue) return ''
            const codeArr = cellValue.split(',')
            const nameArr = []
            codeArr.forEach(code => {
                const find = this.aiIosBookChannelList.find(c => c.channel === code)
                if (find) nameArr.push(find.remark)
            })
            return nameArr.join('、')
        },
        // 是否生效格式化
        statusFormatter(row, column, cellValue) {
            return cellValue === false ? '开启' : '关闭'
        },
        getList() {
            adList(this.queryData).then(resp => {
                this.list = resp.data.info.list
            })
        },
        remove(rowId) {
            this.$confirm('删除？', '提示', {type: 'warning'}).then(() => {
                removeAdId({id: rowId}).then(() => {
                    this.$message.success('删除成功');
                    this.getList();
                })
            }).catch(() => {
            })
        },

        async showSaveFormDialog(title, id) {
            this.dialogTitle = title;
            this.saveBase = {
                id: null, appId: null, channels: [], remark: null, versionCode: null, deleted: false
            };
            this.detailList = [this.getOriginalDetail()];
            this.originalBase = null;
            this.dialogVisible = true;

            if (!id) return;

            let res = await adDetails({id: id});
            const data = res.data.info;

            this.originalBase = data.base;

            this.saveBase.id = data.base.id;
            this.saveBase.appId = data.base.appId;
            this.saveBase.remark = data.base.remark;
            this.saveBase.versionCode = data.base.versionCode;
            this.saveBase.deleted = data.base.deleted;

            // 编辑回显只映射3个字段
            this.detailList = (data.list || []).map(item => ({
                ab: item.ab,
                rate: item.rate,
                topon_splashId: item.topon_splashId,
                topon_hotSplashId: item.topon_hotSplashId,
                topon_InterstitialId: item.topon_InterstitialId,
                deviceCode: item.deviceCode,
            }));

            const channelStr = data.base.channels || '';
            this.saveBase.channels = channelStr.split(',');
        },

        confirmForm() {
            if (!this.saveBase.channels.length) return this.$message.error('渠道必选');
            if (!this.saveBase.appId) return this.$message.error('应用必选');
            if (!this.saveBase.remark) return this.$message.error('备注必填');

            const submitData = {
                base: {
                    ...this.originalBase,
                    ...this.saveBase,
                    channels: this.saveBase.channels.join(',')
                },
                detailList: this.detailList
            };

            saveAdId(submitData).then(res => {
                if (res.data.status === 0) {
                    this.$message.success('保存成功');
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }
    },
    created() {
        this.getList();
        appAll().then(res => this.apps = res.data.info);
        kittyChannelList().then(res => this.aiIosBookChannelList = res.data.info);
    }
}
</script>

<style scoped>
</style>